<template>
    <!--
    Button back component
    Calls browser history back function or navigates to
    given path

    @property {String} path
    -->
    <button @click.prevent="navigate" class="btn-back">
        <icon name="arrow-back"/>
    </button>
</template>

<script>
import {mapState} from 'vuex';

export default
{
    name: 'BackButton',

    props:
    {
        path:
        {
            type: String,
            required: true
        },
    },

    methods:
    {
        /**
         * Trigger window history back function
         */
        navigate()
        {
            this.$router.push(this.$onduro.route(this.path));
        }
    },
}
</script>



// WEBPACK FOOTER //
// ButtonBack.vue?d98fbd72